
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as loginOl84J9_AHH9A75q8OlyZtme3OFntWQgXeSBZ5ez230UMeta } from "/vercel/path0/app/pages/admin/login.vue?macro=true";
import { default as _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_wRcqM9kt2Zm5YMeta } from "/vercel/path0/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta } from "/vercel/path0/app/pages/deploy/[slug].vue?macro=true";
import { default as _91slug_93br5bsBMaFUldu9ZW3X_bIirDQhXcQ74oasqLdJl3UNUMeta } from "/vercel/path0/app/pages/modules/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_IMeta } from "/vercel/path0/app/pages/docs/[...slug].vue?macro=true";
import { default as indexQYufR705eSA0Alb_DtstO3BC68H4U3RBsMP5nSZmzYAMeta } from "/vercel/path0/app/pages/admin/index.vue?macro=true";
import { default as indexaRLkqFYQWbP0_Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta } from "/vercel/path0/app/pages/blog/index.vue?macro=true";
import { default as changelogKxsbZD4y_IP3pSKbRbn1mdFOxI_CROFok8oWaoo7nYUMeta } from "/vercel/path0/app/pages/changelog.vue?macro=true";
import { default as indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta } from "/vercel/path0/app/pages/deploy/index.vue?macro=true";
import { default as design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta } from "/vercel/path0/app/pages/design-kit.vue?macro=true";
import { default as _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_k30_eVSubgbkdVX6QMeta } from "/vercel/path0/app/pages/enterprise/agencies/[slug].vue?macro=true";
import { default as indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta } from "/vercel/path0/app/pages/enterprise/agencies/index.vue?macro=true";
import { default as jobsui3znLVjPPi1uvIO7NuS_QJIZwM8xy_LgNPI4ttmQTUMeta } from "/vercel/path0/app/pages/enterprise/jobs.vue?macro=true";
import { default as sponsorsqSnf0SJ24yxiQ_ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta } from "/vercel/path0/app/pages/enterprise/sponsors.vue?macro=true";
import { default as support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta } from "/vercel/path0/app/pages/enterprise/support.vue?macro=true";
import { default as enterprise9ZB5_KjAa7UI_UGnVlj_3tEPjG0IO0V6UQoFvkfKQEAMeta } from "/vercel/path0/app/pages/enterprise.vue?macro=true";
import { default as evalsb0528xcxak07wlT3mBVUw2ssJTgSpx3Jp7XrsoLPZFcMeta } from "/vercel/path0/app/pages/evals.vue?macro=true";
import { default as indexujR_H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta } from "/vercel/path0/app/pages/modules/index.vue?macro=true";
import { default as newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_9hqvAMGSs5DZn3kMeta } from "/vercel/path0/app/pages/newsletter.vue?macro=true";
import { default as showcaseh9CKeTtaFu9RmDzFH_LBfcr7mWlQo4cXJ_whU51AJZAMeta } from "/vercel/path0/app/pages/showcase.vue?macro=true";
import { default as teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__bsNWFWsNxJAMeta } from "/vercel/path0/app/pages/team.vue?macro=true";
import { default as templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta } from "/vercel/path0/app/pages/templates.vue?macro=true";
import { default as video_45coursesNEh0ujp9_IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta } from "/vercel/path0/app/pages/video-courses.vue?macro=true";
import { default as indexXNEFQ_BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_3422d6a04055dad23f81af55cef51739/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU } from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_3422d6a04055dad23f81af55cef51739/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "admin-login",
    path: "/admin/login",
    meta: { ...(loginOl84J9_AHH9A75q8OlyZtme3OFntWQgXeSBZ5ez230UMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/app/pages/admin/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_wRcqM9kt2Zm5YMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/[slug].vue")
  },
  {
    name: "deploy-slug",
    path: "/deploy/:slug()",
    meta: _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/[slug].vue")
  },
  {
    name: "modules-slug",
    path: "/modules/:slug()",
    meta: _91slug_93br5bsBMaFUldu9ZW3X_bIirDQhXcQ74oasqLdJl3UNUMeta || {},
    component: () => import("/vercel/path0/app/pages/modules/[slug].vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_IMeta || {},
    component: () => import("/vercel/path0/app/pages/docs/[...slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexQYufR705eSA0Alb_DtstO3BC68H4U3RBsMP5nSZmzYAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/app/pages/admin/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexaRLkqFYQWbP0_Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/index.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: changelogKxsbZD4y_IP3pSKbRbn1mdFOxI_CROFok8oWaoo7nYUMeta || {},
    component: () => import("/vercel/path0/app/pages/changelog.vue")
  },
  {
    name: "deploy",
    path: "/deploy",
    meta: indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/index.vue")
  },
  {
    name: "design-kit",
    path: "/design-kit",
    meta: design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta || {},
    component: () => import("/vercel/path0/app/pages/design-kit.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/vercel/path0/app/pages/enterprise.vue"),
    children: [
  {
    name: "enterprise-agencies-slug",
    path: "agencies/:slug()",
    meta: _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_k30_eVSubgbkdVX6QMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/[slug].vue")
  },
  {
    name: "enterprise-agencies",
    path: "agencies",
    meta: indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/index.vue")
  },
  {
    name: "enterprise-jobs",
    path: "jobs",
    meta: jobsui3znLVjPPi1uvIO7NuS_QJIZwM8xy_LgNPI4ttmQTUMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/jobs.vue")
  },
  {
    name: "enterprise-sponsors",
    path: "sponsors",
    meta: sponsorsqSnf0SJ24yxiQ_ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/sponsors.vue")
  },
  {
    name: "enterprise-support",
    path: "support",
    meta: support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/support.vue")
  }
]
  },
  {
    name: "evals",
    path: "/evals",
    meta: evalsb0528xcxak07wlT3mBVUw2ssJTgSpx3Jp7XrsoLPZFcMeta || {},
    component: () => import("/vercel/path0/app/pages/evals.vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: indexujR_H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta || {},
    component: () => import("/vercel/path0/app/pages/modules/index.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_9hqvAMGSs5DZn3kMeta || {},
    component: () => import("/vercel/path0/app/pages/newsletter.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcaseh9CKeTtaFu9RmDzFH_LBfcr7mWlQo4cXJ_whU51AJZAMeta || {},
    component: () => import("/vercel/path0/app/pages/showcase.vue")
  },
  {
    name: "team",
    path: "/team",
    meta: teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__bsNWFWsNxJAMeta || {},
    component: () => import("/vercel/path0/app/pages/team.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta || {},
    component: () => import("/vercel/path0/app/pages/templates.vue")
  },
  {
    name: "video-courses",
    path: "/video-courses",
    meta: video_45coursesNEh0ujp9_IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta || {},
    component: () => import("/vercel/path0/app/pages/video-courses.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexXNEFQ_BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta || {},
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/getting-started",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/getting-started",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/getting-started",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/getting-started",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/concepts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/concepts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/concepts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/concepts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/going-further",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/going-further",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/going-further",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/going-further",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/going-further/edge-release-channel",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/going-further/edge-release-channel",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/going-further/edge-release-channel",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/going-further/edge-release-channel",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/bridge",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/bridge",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/bridge",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/bridge",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/migration",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/migration",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/migration",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/migration",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/kit",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/kit",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/kit",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/kit",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/commands",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/commands",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/commands",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/commands",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/api/configuration/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/api/configuration/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/configuration/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/configuration/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/examples",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/examples",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/examples/features",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/examples/features",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/features",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/features",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/examples/routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/examples/routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/examples/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/examples/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/advanced",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/examples/experimental",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/examples/experimental",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/experimental",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/experimental",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/community/nuxt-community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/community/nuxt-community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/community/nuxt-community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/community/nuxt-community",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/recipes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/recipes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/recipes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/recipes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/best-practices",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/best-practices",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/best-practices",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/best-practices",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/concepts/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/concepts/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/concepts/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/concepts/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/guide/going-further/custom-routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/going-further/custom-routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/going-further/custom-routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/going-further/custom-routing",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/directory-structure/app/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/directory-structure/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/directory-structure/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/:pathMatch(.*)",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/assets",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/assets",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/assets",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/layouts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/layouts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/layouts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/pages",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/pages",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/pages",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/plugins",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/plugins",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/plugins",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure-config/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/guide/directory-structure/app-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/guide/directory-structure/app-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/error",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/error",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/error",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxt",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/nuxt",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/output",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/output",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/assets",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/assets",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/components",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/composables",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/layouts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/layouts",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/middleware",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/pages",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/pages",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/plugins",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/plugins",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/utils",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/app",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/app-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/app-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/error",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/app/error",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/content",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/content",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/node_modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/node_modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/public",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/public",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/server",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/server",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/shared",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/shared",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/env",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/env",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/gitignore",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/gitignore",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxtignore",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/nuxtignore",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxtrc",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/nuxtrc",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/nuxt-config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/package",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/package",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/tsconfig",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/tsconfig",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/support/us",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/ai",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/ai",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/3.x/guide/ai",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/12go.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/git-lab.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/mc-donalds-france.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/stack-overflow.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/armani.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/google-ventures.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/microsoft-edge-developer.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/the-north-face.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/buy-mea-coffee.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/hai.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/n8n.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/tiktok-ads.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/caudalie.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/harrods.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/nasa-jet-propulsion-laboratory.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/timberland.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/clean-shot-x.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/hostel-world.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/on-running.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/too-good-to-go.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/croix-rouge.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/hostinger.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/paul-smith.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/toolstation.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/delvaux.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/icons8.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/promod.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/trade-republic.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/departamento.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/immersive-garden.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/push-security.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/upwork.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/directus.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/le-collectionist.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/roland-garros.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/vans.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/explore-france.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/louis-vuitton.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/shaina-mote.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/assets/websites/virgin-galactic.png",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/essentials/hello-world",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/essentials/hello-world",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/composables/usehead",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/composables/usehead",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/composables/use-async-data",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/composables/use-async-data",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/examples/composables/use-head",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/examples/composables/use-head",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/getting-started/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/getting-started/directory-structure",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/going-further/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/going-further/modules",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/concepts/rendering-modes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/concepts/rendering-modes",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxt.config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/nuxt.config",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/getting-started/hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/getting-started/hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/api/nuxt-hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/api/nuxt-hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/guide/directory-structure/hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/guide/directory-structure/hooks",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/4.x/robots.txt",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/docs/5.x/robots.txt",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  },
  {
    name: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mUMeta?.name,
    path: "/deploy/nuxthub",
    component: component_45stubeKHf35DbJVdTQo5SDDnAx32sNX0XGNAg8rIDBxH80mU
  }
]